import React, { Component } from 'react';
import {
    Container,
    Row, Col
} from 'reactstrap';
import PermissionWrapper from '../../auth/PermissionWrapper';

import CompanyContext from '../../auth/CompanyContext';

class CRMReports extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            reportsIsLoading: true,
        };
        this.mounted = false;
    }

    componentDidMount = () => {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <PermissionWrapper {...this.props} allowedPermission="Reports">
                <Container fluid className='p-9'>
                    <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                        <Row>
                            <Col md={12} className='text-center'>
                                <h1>CRM Reports</h1>
                            </Col>
                        </Row>
                    </PermissionWrapper>
                </Container>
            </PermissionWrapper>
        );
    }
}

export default CRMReports;
